function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import './OutlineButton.scss';
import clsx from 'clsx';
const OutlineButton = ({
  label,
  icon,
  white,
  className,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: clsx('outline-button', icon && !label && 'square', white && 'white', className)
  }), icon && /*#__PURE__*/React.createElement("span", {
    className: `outline-button-icon icon ${icon}`
  }), label && /*#__PURE__*/React.createElement("div", {
    className: "outline-button-label"
  }, label));
};
export default OutlineButton;